import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import { CLI_COMMAND_NAME } from "Constants/documentationUrls";

import * as S from "./DeleteEnvWithoutIntegration.style";
import * as StatusSettings from "./StatusSettings.style";

import type { Environment } from "@packages/client";

interface DeleteEnvWithoutIntegrationProps {
  environment: Environment;
  openDeleteConfirm: () => void;
}

export const DeleteEnvWithoutIntegration = ({
  openDeleteConfirm,
  environment
}: DeleteEnvWithoutIntegrationProps) => {
  const intl = useIntl();
  return (
    <>
      <Typography.BodyText size="small">
        {intl.formatMessage({
          id: "status_active_delete_description"
        })}
      </Typography.BodyText>
      <S.DeleteButton
        onClick={openDeleteConfirm}
        analyticId="delete_environment"
      >
        {intl.formatMessage({
          id: "delete_environment"
        })}
      </S.DeleteButton>
      <S.StatusSettingBodyText size="small">
        {intl.formatMessage({
          id: "cli_command"
        })}
      </S.StatusSettingBodyText>

      <StatusSettings.CodeBlock
        singleLine
        isCopyable
        id="platform_delete_env_cmd"
      >
        {intl.formatMessage(
          { id: "platform_delete_env_cmd" },
          { cli_name: CLI_COMMAND_NAME, envName: environment.name }
        )}
      </StatusSettings.CodeBlock>
    </>
  );
};
